module.exports = __webpack_public_path__ + "static/media/jc-logo-lightpink.5b77927c.png";